import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useCompleteJobMutation } from '../../../../features/jobs/jobsApiSlice';
import Modal from '../../../HeaderContainer/Popup/Modal';

const CompleteJobModal = ({ open, onClose, onCompleted, jobId, jobTitle, master }) => {
    const { t } = useTranslation();
    const [rating, setRating] = useState(0);
    const [comment, setComment] = useState('');
    const [error, setError] = useState('');
    const [completeJob, { isLoading }] = useCompleteJobMutation();
    const profilePhotosPath = process.env.REACT_APP_PROFILE_PHOTOS_PATH;

    const close = () => {
        if (isLoading) return;
        setRating(0);
        setComment('');
        setError('');
        onClose();
    };

    const submit = async () => {
        if (rating < 1 || rating > 5) {
            setError(t('RatingRequired'));
            return;
        }
        try {
            await completeJob({ jobId, rating, comment: comment.trim() }).unwrap();
            onCompleted?.();
        } catch (requestError) {
            setError(t(requestError?.data?.message || 'JobCompletionFailed'));
        }
    };

    return <Modal open={open} onClose={close} tabs={[t('CompleteAndRate')]}> 
        <div className="container">
            <div className="col margin-bottom-30 margin-top-20">
                <div style={{ display: 'flex', alignItems: 'center', gap: 14, marginBottom: 18 }}>
                    {master?.avatar && <img src={`${profilePhotosPath}${master.avatar}`}
                        alt="" style={{ width: 58, height: 58, objectFit: 'cover', borderRadius: '50%' }} />}
                    <div>
                        <strong>{master?.firstName} {master?.lastName}</strong>
                        <div>{jobTitle}</div>
                    </div>
                </div>

                <h5>{t('RateMasterRequired')}</h5>
                <div role="radiogroup" aria-label={t('RateMasterRequired')}
                    style={{ display: 'flex', gap: 6, margin: '10px 0 18px' }}>
                    {[1, 2, 3, 4, 5].map(star => <button key={star} type="button"
                        role="radio" aria-checked={rating === star}
                        onClick={() => { setRating(star); setError(''); }}
                        style={{ border: 0, background: 'transparent', padding: 2, cursor: 'pointer',
                            color: star <= rating ? '#febe42' : '#c7c7c7', fontSize: 34 }}>★</button>)}
                </div>

                <label htmlFor="completion-comment"><strong>{t('ReviewOptional')}</strong></label>
                <textarea id="completion-comment" className="with-border" rows="4" maxLength="255"
                    value={comment} onChange={event => setComment(event.target.value)} />
                <div style={{ textAlign: 'right', fontSize: 12 }}>{comment.length}/255</div>
                {error && <div role="alert" style={{ color: '#b42318', marginTop: 8 }}>{error}</div>}

                <div className="row margin-top-20">
                    <div className="col-xl-7 col-md-7">
                        <button onClick={submit} disabled={isLoading}
                            className="button big full-width ripple-effect" type="button">
                            {isLoading ? t('Saving') : t('CompleteAndRate')}
                        </button>
                    </div>
                    <div className="col-xl-5 col-md-5">
                        <button onClick={close} disabled={isLoading}
                            className="button gray big full-width ripple-effect" type="button">{t('Cancel')}</button>
                    </div>
                </div>
            </div>
        </div>
    </Modal>;
};

export default CompleteJobModal;
